export default theme => ({
	typography: {
		padding: theme.spacing(2),
	},
});
